import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from 'react-hook-form';
import { PSSubmit } from "components/globals/ui/input/PSInputs";
import { prepareFormData } from "helpers/utils";
import { updateUserSetting } from 'store/authSlice'
import { useDispatch } from 'react-redux'
import PSFormLightswitch from "components/globals/ui/input/PSFormLightswitch";

const SettingContainer = function ({children}) {
	return (
		<div className="rounded-lg bg-[#ffffff] mb-3 p-2 md:p-4">
			{children}
		</div>
	)
}

const SettingHeading = function ({text}) {
	return (
		<h4 className="mb-3 text-xl ">{text}</h4>
	)
}

const UpdateSuccess = function ({text}) {
	return (
		<div className="inline-flex rounded-lg items-center bg-green py-3 px-5 text-black block my-2">
			<p>{text}</p>
		</div>
	)
}

export const UpdateEmailSettings = function ({ userInfo }) {
	const [success, setSuccess] = useState(null);
	const dispatch = useDispatch();
	const form = useForm();

	const { handleSubmit, register, setError, formState, setValue, control } = form;
	const { errors } = formState;

	useEffect(() => {
		if (userInfo?.emailSettings) {
			const settings = userInfo.emailSettings;
	
			setValue("userComments", settings.userComments ?? false);
			setValue("userLikes", settings.userLikes ?? false);
			setValue("userFollowed", settings.userFollowed ?? false);
			setValue("followerActivity", settings.followerActivity ?? false);
		}
	
		if (userInfo?.user_id) {
			setValue("userid", userInfo.user_id);
		}
	}, [userInfo, setValue]);

	const submitForm = async (data) => {
		const formData = prepareFormData(data);

		formData.append("emailSettings", JSON.stringify({
			userComments: data.userComments,
			userLikes: data.userLikes,
			userFollowed: data.userFollowed,
			followerActivity: data.followerActivity,
		}));
	

		try {
			const response = await dispatch(updateUserSetting({ type: "emailSettings", formData })).unwrap();
			if (response.success === true) {
				setSuccess("success");
			}
		} catch (error) {
			setError("server", {
				type: "manual",
				message: error.message || "Failed to update settings",
			});
		}
	};

	return (
		<>
			<SettingContainer>
				<SettingHeading text="Update Email Contact Settings" />

				{success && <UpdateSuccess text="Successfully updated email contact settings" />}

				<FormProvider {...form}>
					<form onSubmit={handleSubmit(submitForm)}>
						<div className="mb-6">
							<PSFormLightswitch
								name="userComments"
								label="Email when you receive a comment"
								control={control}
							/>
						</div>
						
						<div className="mb-6">
							<PSFormLightswitch
								name="userLikes"
								label="Email when you receive a like"
								control={control}
							/>
						</div>
						
						<div className="mb-6">
							<PSFormLightswitch
								name="followerActivity"
								label="Email when someone you follow posts content"
								control={control}
							/>
						</div>

						<div className="mb-6">
							<PSFormLightswitch
								name="userFollowed"
								label="Email when someone follows you"
								control={control}
							/>
						
						</div>
						<PSSubmit label="Update" />
					</form>
				</FormProvider>
			</SettingContainer>
		</>
	);
};


